import React, { useEffect, useState } from "react";
import { RefreshCw, CheckCircle2, AlertCircle } from "lucide-react";
import api from "@/lib/api";

function timeAgo(iso) {
  if (!iso) return "not yet";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h ago`;
  return `${Math.floor(diff / 86400)} d ago`;
}

export default function SyncBadge() {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get("/zoho/status").then((r) => setStatus(r.data)).catch(() => {});
  }, []);

  if (!status) return null;
  const live = status.status === "live";
  const syncing = status.status === "syncing";
  const label = live ? "Zoho Inventory Live Sync" : syncing ? "Syncing with Zoho..." : "Zoho Inventory Sample Mode";
  const dot = live ? "bg-emerald-500" : "bg-amber-500";

  return (
    <div
      data-testid="zoho-sync-badge"
      className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white pl-2.5 pr-3 py-1.5 text-xs"
    >
      <span className={`relative flex h-2 w-2`}>
        <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${dot}`} />
        <span className={`relative inline-flex rounded-full h-2 w-2 ${dot}`} />
      </span>
      <span className="font-medium text-slate-700">{label}</span>
      <span className="text-slate-400 font-mono-num">· {timeAgo(status.last_synced)}</span>
    </div>
  );
}
